import { useTheme } from "@mui/material";

export const Divider = () => {
    const theme = useTheme();
    return (
        <hr style={{ width: "100%", borderBottom: theme.styles.altBorder1, borderTop: "none", margin: 0 }} />
    );
};
